export default __webpack_public_path__ + "img/logo-ssl.6b19ad5.svg";